<template>
  <div class="applications-container">
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Financial Libilites</h1>
      </div>
    </div>

    <div>
      <form id="form10" autocomplete="off" class="mt-40">
        <div class="container w-100" style="font-size: 18px">

          <div v-for="newContent in temp" :key="newContent.id">
            <div class="liabilities-container mb-20">
              <div class="col-sm-6 col-md-6">
                <span>Liabilities Type</span>
                <select v-model="newContent.selected">
                  <option value="" disabled>Select Liabilities</option>
                  <option v-for="(option, index) in options" :key="index" v-bind:value="option.value">{{ option.label }}</option>
                </select>
              </div>

              <div class="liabilities-content">

                <div v-if="newContent.selected == 'Mortgage Loan'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Mortgage Type</span>
                    <select>
                      <option selected="selected" value="" disabled>Select</option>
                      <option value="Owner occupied">Owner occupied</option>
                      <option value="Investment">Investment</option>
                    </select>
                  </div>
                  <div class="clear"></div>

                  <div class="mt-10 pl-15 pr-15">
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Lender</span>
                        <input type="text" class="input-common-lg w-100"/>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Loan Term Expiry Date</span>
                        <input type="date" class="input-common-lg w-100"/>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Repayment Type</span>
                        <select>
                          <option selected="selected" value="" disabled>Select</option>
                          <option value="Principal & interest">Principal & interest</option>
                          <option value="Interest only">Interest only</option>
                        </select>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Interest Rate</span>
                        <div class="input-group">
                          <input type="text" class="form-control input-common-lg">
                          <div class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-12 col-md-12">
                        <span>Link Asset</span>
                        <select>
                          <option selected="selected" value="" disabled>Select</option>
                        </select>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>BSB</span>
                        <input type="text" class="form-control input-common-lg">
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Account Number</span>
                        <input type="text" class="form-control input-common-lg">
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Limit</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Balance</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10 flx align-items-center">
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership %</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 d-flex flex-column jutify-content-center">
                        <label>
                          <input type="checkbox" class=""> Refinance
                        </label>
                      </div>
                    </div>

                  </div>

                </div>
                <!-- END Mortgage Loan opt -->

                <div v-if="newContent.selected == 'Credit Card'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Credit Card Type</span>
                    <select required="">
                      <option selected="selected" value="" disabled>Select</option>
                      <option value="VISA">VISA</option>
                      <option value="Mastercard">Mastercard</option>
                      <option value="AMEX">AMEX</option>
                      <option value="Store Card">Store Card</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Lender</span>
                        <input type="text" class="input-common-lg w-100"/>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Maximum Card Limit</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Balance</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Interest Rate</span>
                        <div class="input-group">
                          <input type="text" class="form-control input-common-lg">
                          <div class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership %</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <!-- END Credit Card opt -->

                <div v-if="newContent.selected == 'Vehicle Loan'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Linked Asset</span>
                    <select required="">
                      <option selected="selected" value="" disabled>Select</option>
                    </select>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">
                    
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Lender</span>
                        <input type="text" class="input-common-lg w-100"/>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Net Amount Financed</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Balance</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Interest Rate</span>
                        <div class="input-group">
                          <input type="text" class="form-control input-common-lg">
                          <div class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership %</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Account/Loan Number</span>
                        <input type="text" class="w-100 input-common-lg">
                      </div>
                    </div>

                  </div>

                </div>
                <!-- END Vehicle Loan opt -->

                <div v-if="newContent.selected == 'Personal Loan'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Account/Loan Number</span>
                    <input class="input-common-lg w-100" type="text"/>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">
                    
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Lender</span>
                        <input type="text" class="input-common-lg w-100"/>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Net Amount Funanced</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Balance</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Interest Rate</span>
                        <div class="input-group">
                          <input type="text" class="form-control input-common-lg">
                          <div class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership %</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <!-- END Personal Loan opt -->

                <div v-if="newContent.selected == 'Student Loan' || newContent.selected == 'Other' || newContent.selected == 'Balance Sheet'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Account/Loan Number</span>
                    <input class="input-common-lg w-100" type="text"/>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">
                    
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Lender</span>
                        <input type="text" class="input-common-lg w-100"/>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Net Amount Funanced</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Balance</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership %</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <!-- END Super fund opt -->

              </div>

              <div class="clear"></div>

              <div v-if="newContent.id!=0" class="flx pointer change-employment-btn pt-10" style="width: max-content" @click="removeLiability($event, newContent.id)">
                <div class="reduce-icon">-</div>
                <div>Remove Liability</div>
              </div>

            </div>
          </div>


          <div class="clear">
            <div class="flx pointer change-employment-btn pt-10 addEmploymentBtn" style="width: max-content" @click="addLiability()" >
              <div class="add-icon">+</div>
              <span>Add New Liability</span>
            </div> 
          </div>

        </div>
      </form>
    </div>
    
    <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('financial-assets')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('post-settlement')">CONTINUE</a>
    </div>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  data(){
    return {
      id: 0,
      options: [
        {value:"Mortgage Loan",label:"Mortgage Loan"},
        {value:"Credit Card",label:"Credit Card"},
        {value:"Vehicle Loan",label:"Vehicle Loan"},
        {value:"Personal Loan",label:"Personal Loan"},
        {value:"Student Loan",label:"Student Loan"},
        {value:"Other",label:"Other"},
        {value:"Balance Sheet",label:"Balance Sheet"},], 
      temp: [{id: 0,selected:""}],}
  },
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
    addLiability(){
      var new_id = 0;
      do{++new_id;}while(this.temp.find(e => e.id === new_id));
      this.temp.push({
        id: new_id
      })
    },
    removeLiability(event, id){
      var index = this.temp.map(object => object.id).indexOf(id);
      this.temp.splice(index,1);
    },
  },
};
</script>
